<template>
    <v-col cols="6" md="4" class="py-10 pa-lg-30">
        <div class="border-top w-100 pt-16 pt-md-18">
            <p class="page-text-lg font-weight-medium" :class="dupont ? 'mb-10 mb-lg-16' : 'mb-20 mb-lg-32'">
                {{ company }}
            </p>
            <v-img :src="src" :max-width="width"></v-img>
        </div>
    </v-col>
</template>

<script>
export default {
    props: {
        company: { type: String, default: "" },
        src: { type: String, default: "" },
        width: { type: String, default: "" },
        dupont: { type: Boolean, default: false },
    },
    components: {},
    data: () => {
        return {};
    },
    created() {},
    // mounted() {
    // 	this.init();
    // },
    // methods : {
    // 	init : function() {
    //         setTimeout(() => {
    //             AOS.init({
    //                 once: false,
    //                 offset: 240,
    //                 duration: 500,
    //                 throttleDelay : 100,
    //                 easing : 'ease-in-out',
    //                 anchorPlacement : 'top-center',
    //             });
    //         }, 100);
    // 	}
    // },
};
</script>

<style scoped>
</style>